import React from 'react';
import ProgramYearFilter from '../../shared/components/ProgramYearFilter';
import { APPRAISAL_COMPARISON_FILTER_TYPES } from '../../../constants/appraisal-comparison-filter-types';
import MultiItemUpDown from '../../shared/components/MultiItemUpDown';

/**
 * @typedef {object} AppraisalComparisonFiltersProps
 * @property {Object} [data]
 * @property {number} [selectedAppraisalId]
 * @property {(selectedAppraisalId: number) => void} [setSelectedAppraisalId]
 * @property {Object} [comparisonType]
 * @property {(selectedValue: { key: string, value: string, showUnitLine: boolean }) => void} [setComparisonType]
 * @property {boolean} [loading]
 */

/**
 * @param {AppraisalComparisonFiltersProps} props
 */
const AppraisalComparisonFilters = props => {
  const {
    data,
    comparisonType,
    setComparisonType,
    selectedAppraisalId,
    setSelectedAppraisalId,
    loading
  } = props;

  const comparisonOptions = APPRAISAL_COMPARISON_FILTER_TYPES;

  const programYearOptions = data
    ? data.appraisalComparisonOrgUnit.AppraisalOrgUnits.map(ou => ({
        value: ou.AppraisalProgramYear,
        key: ou.Appraisal.Id
      })).reverse()
    : [];

  const handleOnChangeComparisonOption = value => {
    const selectedValue = comparisonOptions.find(c => c.key == value);
    setComparisonType(selectedValue);
  };

  return (
    <div className='appraisal-comparison-filters'>
      <div className='dropdown-box'>
        <p className='bold'>Comparison</p>
        <MultiItemUpDown
          data-testid='select-comparison'
          disabled={comparisonOptions === undefined || comparisonOptions.length === 0}
          options={comparisonOptions}
          value={comparisonType.key}
          setValue={handleOnChangeComparisonOption}
          selectId='selected-comparison-item'
          upDownId='select-comparison'
        />
      </div>

      <div className='dropdown-box'>
        <p className='bold'>Program Year</p>
        <ProgramYearFilter
          handleOnChange={setSelectedAppraisalId}
          programYearOptions={programYearOptions}
          selectedAppraisalId={selectedAppraisalId}
          loading={loading}
        />
      </div>
    </div>
  );
};

export default AppraisalComparisonFilters;
